import request from 'api/request';

export default function closeTicketRoute(id) {
  return request({ url: `/tickets/${id}/close`, method: 'POST' });
}
